<tech-tab-group [(selectedTab)]="tabSelected">
  <tech-tab>
    <tech-tab-label>
      <tech-icon>home</tech-icon>
    </tech-tab-label>
    <tech-tab-content> </tech-tab-content>
  </tech-tab>
  <tech-tab>
    <tech-tab-label>
      {{ 'general.accountReceipt' | translate }}
    </tech-tab-label>
    <tech-tab-content>
      <app-receipt-account> </app-receipt-account>
    </tech-tab-content>
  </tech-tab>
  <tech-tab>
    <tech-tab-label>
      {{ 'general.accountReturn' | translate }}
    </tech-tab-label>
    <tech-tab-content>
      <app-receipt-account-return> </app-receipt-account-return>
    </tech-tab-content>
  </tech-tab>
  <tech-tab>
    <tech-tab-label>
      {{ 'general.cardReceipt' | translate }}
    </tech-tab-label>
    <tech-tab-content>
      <app-receipt-card> </app-receipt-card>
    </tech-tab-content>
  </tech-tab>
  <tech-tab>
    <tech-tab-label>
      {{ 'general.cardReturn' | translate }}
    </tech-tab-label>
    <tech-tab-content>
      <app-receipt-card-return> </app-receipt-card-return>
    </tech-tab-content>
  </tech-tab>
  <tech-tab>
    <tech-tab-label>
      {{ 'general.paypalReceipt' | translate }}
    </tech-tab-label>
    <tech-tab-content>
      <app-receipt-paypal></app-receipt-paypal>
    </tech-tab-content>
  </tech-tab>
  <tech-tab>
    <tech-tab-label>
      {{ 'general.transferReceipt' | translate }}
    </tech-tab-label>
    <tech-tab-content>
      <app-receipt-transfer> </app-receipt-transfer>
    </tech-tab-content>
  </tech-tab>
  <tech-tab>
    <tech-tab-label>
      {{ 'general.latamReceipt' | translate }}
    </tech-tab-label>
    <tech-tab-content>
      <app-receipt-latam> </app-receipt-latam>
    </tech-tab-content>
  </tech-tab>
  <tech-tab>
    <tech-tab-label>
      {{ 'general.multiReturn' | translate }}
    </tech-tab-label>
    <tech-tab-content>
      <app-receipt-return> </app-receipt-return>
    </tech-tab-content>
  </tech-tab>
</tech-tab-group>
